const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "goodsCategory":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "goodsCategory",
    reducer: reducer,
};

export default data;